module.exports = __webpack_public_path__ + "static/media/Style13.ca402338.PNG";